import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    ACCOUNT_DETAILS,
    ACCOUNT_DETAILS_BY_ID,
    ACCOUNT_FILTER,
    DROPDOWN_VALUE,
    FETCH_REPORTEE,
    GEO_CITY,
    GET_ACCOUNT_ACTIVITY,
    SAVE_ACCOUNT,
    UPDATE_ACCOUNT,
    GET_ACCOUNT_ACTIVITY_BY_ID,
    SAVE_ACTIVITY,
    GET_ACCOUNT_ACTIVITY_LIST,
    GET_LEAD_OPPORTUNITY_ACTIVITY_TYPE,
    GET_LAST_LEAD_OPPORTUNITY_ACTIVITY,
    IS_USER_CHECK_IN,
    GET_V2_OPPORTUNITY_ACTIVITY_TYPE, INFRA_PROJECT, SAVE_BUSINESS,
    GET_INSPECTION_LIST, PROFILE
} from "./type";

/**
 *
 * @returns {(function(*): Promise<boolean|undefined>)|*}
 */


export const dropdownData = (opportunityType = 'is_apartment') => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.dropdown}?opprtunity_type=${opportunityType}`
    );
    if (res) {
        const {data} = res;
        dispatch({
            type: DROPDOWN_VALUE,
            payload: data.response.data,
        });
        return true;
    }
};

export const saveAccount = (params) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        params,
        `${Config.saveAccount}`,
    );
    if (res) {
        const {data} = res;
        dispatch({
            type: SAVE_ACCOUNT,
            payload: data.response,
        });
        return true;
    }
};


export const accountDetails = (page = 1, lead_id = 0, searchKey = '', data=[{}], isGlobalSearch = false) => async (dispatch) => {
    let roleId = parseInt(localStorage.getItem('role_id'))
    let urls = ''
    if (lead_id !== 0) {
        urls = `${Config.accountDetails}?page=` + page + "&lead_id=" + lead_id + "&role_id=" + roleId
    } else {
        urls = `${Config.accountDetails}?page=` + page + "&role_id=" + roleId
    }

    const search = window.localStorage.search_account
    if(search){
        searchKey = search
    }

    if(searchKey !== ''){
        urls = urls+"&search_key="+searchKey
    }
    let filters = '';
    Object.keys(data[0]).map((val, i)=>{
        urls+="&"+val+"="+data[0][val]
    })
    const res = await callWebService(
        callTypes.get,
        '',
        urls+"&is_global="+isGlobalSearch
    );
    if (res) {
        const {data} = res;
        dispatch({
            type: ACCOUNT_DETAILS,
            payload: data.response.data,
        });
        return true;
    }
};

export const accountDetailsById = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.accountById}?account_id=` + id
    );
    if (res) {
        const {data} = res;
        dispatch({
            type: ACCOUNT_DETAILS_BY_ID,
            payload: data.response.data,
        });
        return true;
    }
};

export const updateAccount = (params) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        params,
        `${Config.updateAccount}`,
    );
    if (res) {
        const {data} = res;
        dispatch({
            type: UPDATE_ACCOUNT,
            payload: data.response,
        });
        return true;
    }
};

export const fetchReportee = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.fetchReportee}`
    );
    if (res) {
        const {data} = res;
        dispatch({
            type: FETCH_REPORTEE,
            payload: data.response,
        });
        return true;
    }
};

export const getFilter = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.accountFilter}`,
    );
    if (res) {
        const {data} = res;
        dispatch({
            type: ACCOUNT_FILTER,
            payload: data.response,
        });
        return true;
    }
};

export const getCityByStateId = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.fetchCityByStateId}?geo_state_id=`+id,
    );
    if (res) {
        const {data} = res;
        dispatch({
            type: GEO_CITY,
            payload: data.response,
        });
        return true;
    }
};

export const getActivity = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.leadActivities}?type=is_account`,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_ACCOUNT_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const getActivityById = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.accountActivitiesById}?id=`+id,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_ACCOUNT_ACTIVITY_BY_ID,
            payload: data.response,
        });
        return true;
    }
};

export const saveActivity = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.saveLeadOrAccountActivitiesById}`,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const getCreatedActivities = (id, page=1) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.accountActivitiesById}?id=`+id+"&is_all="+true+"&page="+page,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_ACCOUNT_ACTIVITY_LIST,
            payload: data.response.data,
        });
        return true;
    }
};

export const getV2OpportunityActivities = (type, opportunityId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.v2OpportunityActivity}?project_type=`+type+`&opportunity_id=${opportunityId}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_V2_OPPORTUNITY_ACTIVITY_TYPE,
            payload: data.response.data,
        });
        return true;
    }
};

export const getLastLeadOpportunityActivities = (opportunityId, accountId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.lastLeadOpportunityActivity}?opportunity_id=${opportunityId}&account_id=${accountId}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_LAST_LEAD_OPPORTUNITY_ACTIVITY,
            payload: data.response.data,
        });
        return true;
    }
};

export const isUserCheckInForModule = (module_type, module_id, column_name, byUser = false) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.userCheckInForModule}?module_type=${module_type}&module_id=${module_id}&column_name=${column_name}&by_user=${byUser}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: IS_USER_CHECK_IN,
            payload: data.response.data,
        });
        return true;
    }
};

export const infraProject = (projectType, lat, long) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.businessProject}?project_type=${projectType}&lat=${lat}&long=${long}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: INFRA_PROJECT,
            payload: data.response,
        });
        return true;
    }
};

export const saveInfraProject = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.businessSaveProject}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_BUSINESS,
            payload: data.response,
        });
        return true;
    }
};

export const getInspectionListing = (leadId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getInspectionList}?lead_id=${leadId}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_INSPECTION_LIST,
            payload: data.response.data,
        });
        return true;
    }
};

export const getProfile = (roleId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getProfile}?source=leadx&roleId=${roleId}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PROFILE,
            payload: data.response.data,
        });
        return true;
    }
};



